module.exports = {"632823100":"新源镇","632823101":"木里镇","632823102":"江河镇","632823200":"快尔玛乡","632823201":"舟群乡","632823202":"织合玛乡","632823203":"苏里乡","632823204":"生格乡","632823205":"阳康乡","632823206":"龙门乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/632823.json
// module id = 2808
// module chunks = 0